// Utility functions for managing address search history in localStorage

const STORAGE_KEY = 'propertyai_address_history';
const MAX_HISTORY_SIZE = 10; // Keep last 10 addresses

/**
 * Get all address history from localStorage
 * @returns {Array} Array of address objects with {address, timestamp}
 */
export const getAddressHistory = () => {
  try {
    const history = localStorage.getItem(STORAGE_KEY);
    return history ? JSON.parse(history) : [];
  } catch (error) {
    console.error('Error reading address history:', error);
    return [];
  }
};

/**
 * Add an address to history
 * @param {string} address - The address to add
 */
export const addAddressToHistory = (address) => {
  try {
    if (!address || typeof address !== 'string' || address.trim().length === 0) {
      console.log('⚠️ Invalid address, not saving to history');
      return;
    }

    const trimmedAddress = address.trim();
    let history = getAddressHistory();

    console.log('💾 Saving address to history:', trimmedAddress);
    console.log('📋 Current history before save:', history);

    // Remove if already exists (avoid duplicates)
    history = history.filter(item => item.address !== trimmedAddress);

    // Add to beginning of array
    history.unshift({
      address: trimmedAddress,
      timestamp: new Date().toISOString()
    });

    // Keep only last MAX_HISTORY_SIZE items
    if (history.length > MAX_HISTORY_SIZE) {
      history = history.slice(0, MAX_HISTORY_SIZE);
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
    console.log('✅ Address saved to history. New history:', history);
    console.log('✅ Verified in localStorage:', localStorage.getItem(STORAGE_KEY));
  } catch (error) {
    console.error('Error saving address to history:', error);
  }
};

/**
 * Clear all address history
 */
export const clearAddressHistory = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Error clearing address history:', error);
  }
};

/**
 * Remove a specific address from history
 * @param {string} address - The address to remove
 */
export const removeAddressFromHistory = (address) => {
  try {
    let history = getAddressHistory();
    history = history.filter(item => item.address !== address);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
  } catch (error) {
    console.error('Error removing address from history:', error);
  }
};
